import React, { useState, useEffect, useMemo, useRef } from 'react';
import { voiceoptions, PrintModi, channelIcons } from '../lib/constants.js';
import { getGlobalData } from "../lib/globalData"
import {useDropzone} from 'react-dropzone'
import { useReactMediaRecorder } from "react-media-recorder";
import Slider from '../lib/slider';
import Info from '../lib/info';
import DelProj from '../lib/DelProj';
import ArchiveProj from '../lib/ArchiveProj';
import Toggle from '../lib/Toggle';
import Projsettings from '../lib/Projsettings';
import ImagePreviewEditor from '../lib/ImagePreviewEditor';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const Creator = props => {
  const [audio] = useState(new Audio());
  const [project, setProject] = useState({id:false,name:'',edit:0});
  const [tracks, setTracks] = useState([]);
  const [tracksHights, setTracksHights] = useState([]);
  const [nameDirty, setNameDirty] = useState(false);
  const [trackNameDirty, setTrackNameDirty] = useState([]);
  const [recInterval, setRecInterval] = useState(null);
  const [recSecounds, setRecSeconds] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadId, setUploadId] = useState(0);
  const [imageIndex, setImageIndex] = useState(false);
  const [imageProcess, setImageProcess] = useState(false);
  const [translateId, setTranslateId] = useState(false);
  const [lastTransId, setLastTransId] = useState(0);
  const [translating, setTranslating] = useState(0);
  const [translateText, setTranslateText] = useState('');
  const [translated, setTranslated] = useState('');
  const [dateinamen, setDateinamen] = useState(false);
  const [processAudio, setProcessAudio] = useState(true);
  const [infoMsg, setInfoMsg] = useState(false);
  const [settings, setSettings] = useState(false);
  const [kids, setKids] = useState({id:0});
  const [copyQR, setCopyQR] = useState(false);
  const [duplitracks, setDuplitracks] = useState(false);
  const [exportOptions, setExportOptions] = useState(false);
  const [projList, setProjList] = useState([]);
  const [projSel, setProjSel] = useState(0);
  const [trackList, setTrackList] = useState([]);
  const [trackSel, setTrackSel] = useState([]);
  const [channel, setChannel] = useState(0);
  const [imgProps, setImgProps] = useState({scale: 1, offset: {x: 0, y: 0}});

  const savePromisesRef = useRef({});
  const timeoutsRef = useRef(new Map());
  const latestVoiceRef = useRef(new Map());
    
  const { dataprovider, staticel, id, userinfo, setUserField, is_dev } = props;
  const voices = useMemo(()=>project.voices?JSON.parse(project.voices):[], [project.voices]);
  const textareatRef = useRef(null);
  const rahmenFarben = [
    "#000000", "#FFFFFF",
    "#F2C300", "#E67E22", "#C0392B", "#7D3C98",
    "#1F4FD8", "#1E8449", "#7B4A12", "#5F6A6A",
  ];
  const bgFarben = [
    "#FFFFFF", "#F0F0F0", "#FCF4D8",
    "#DEF7FA", "#EDFCED", 
  ];

  const isMobile = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return true;
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
    }

    return false;
  }
  
  const UploadCompleted = (data) => {
    setTracks(data);
    setUploading(false);
  }  

  const changeExportOptions = (f, v) => (ev) => {
    if (v === false) v = ev.target.value;
    setExportOptions((op)=>{ return{...op, [f]:v}})
  }
  
  const updateExportOptions = (f, v) => {
    setExportOptions((op)=>{return {...op, [f]:v}})
  }
  
  const OnStopRec = (audiourl, audioBlob) => {
    setUploading(window.trackid);
    dataprovider.upload('track', window.trackid, audioBlob, UploadCompleted);
    window.trackid = 0;
  }

  const rmr = useReactMediaRecorder({ audio: true, type: "audio/webm", onStop:OnStopRec})
  const {
    error,
    startRecording,
    stopRecording,
//    mediaBlobUrl,
  } = rmr;
  
  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
  }, []);  
  
  useEffect(() => {
    if (rmr.error !== '') {
      clearInterval(recInterval);
      stopRecording();
      setInfoMsg(['', 'Zugriff für den Browser auf das Mikrofon blockiert!'])
    }
  }, [error]);  
  
  useEffect(() => {
    if (id) {
      dataprovider.getRow('project', id, '', setProject);
    }
    else if(userinfo && userinfo.id && userinfo.license>0) {
      CreateProject();
    }
  }, [dataprovider, id, userinfo]);

  const projListLoaded = (data) => {
    setProjList(data);
    if (data.length) {
      setProjSel(data[0].id);
    }
  }
  useEffect(() => {
    dataprovider.getList('project', {sort:['name']}, projListLoaded);
    setTrackSel([]);
  }, [dataprovider, duplitracks]);

  useEffect(() => {
      dataprovider.getList('track', {filter:{id_project:projSel},sort:['channel, pos']}, setTrackList);
  }, [dataprovider, projSel]);

  useEffect(() => {
    if (project.id) {
      dataprovider.getList('track', {filter:{id_project:project.id},sort:['channel, pos']}, setTracks);
    }
  }, [dataprovider, project]);

  useEffect(() => {
    const ta = textareatRef.current;
    if (!ta || !tracks) return;
    const heights = tracks.map((tr) => {
      ta.value = tr.name.split("\n")[0];
      ta.style.height = "0px";
      const scrollHeight = ta.scrollHeight;
      return scrollHeight;
    })
    setTracksHights(heights);
  }, [tracks]);
  
  const CreateProjectDone = (data) => {
    var loc = window.location.hash.split('/');
    window.location.hash = loc[0]+'/'+data.id;
  }
  const MeineProjkete = () => {
    window.location.href="/app#bibliothek?proj=1";
  }
  const CreateProject = () => {
    setChannel(0); 
    dataprovider.insert('project', {}, CreateProjectDone);
  }
  const DeleteProjectDone = () => {
    window.location.hash = 'bibliothek';
  }
  const DeleteProject = (ev) => {
    dataprovider.del('project/'+project.id, {}, DeleteProjectDone);
  }
  
  const HandleNameChange = (ev) => {
    setProject({...project, name:ev.target.value});
    if (nameDirty) {
      clearTimeout(nameDirty);
    }
    setNameDirty(setTimeout(PostNameChange.bind(null, ev.target.value), 1000));
  }
  const PostNameChange = (name) => {
    setNameDirty(false);
    dataprovider.update('project', {id:project.id, name:name}, project.id?null:CreateProjectDone);
  }

  const PostSettingChange = (field, value) => {
    setProject({...project, [field]:value});
    dataprovider.update('project', {id:project.id, [field]:value}, project.id?null:CreateProjectDone);
  }

  const HandleDateinamen = (ev) => {
    setDateinamen(ev.target.checked);
  }
  const HandleProcessAudio = (ev) => {
    setProcessAudio(ev.target.checked);
  }

  const applyImage = () => {
    if (Math.round(imgProps.scale*10)!==1 || Math.abs(imgProps.offset.x)>1 || Math.abs(imgProps.offset.y)>1) {
      dataprovider.update('track/imgprops/' + tracks[imageIndex].id, { imgProps: JSON.stringify(imgProps) });
      setTracks(tr => tr.map((tr, k) => k===imageIndex?{...tr, img_props:JSON.stringify(imgProps)}:tr));
    }
    setImageIndex(false);
  }
  const HandleTrackNameChange = (k, talk) => (ev) => {
    const rows = [...tracks];
    const row = {...rows[k]};
    row.name = ev.target.value;
    if (talk) {
      row.name = talk[1] + '@' + ev.target.value;
    }
    rows[k] = row;
    setTracks(rows);
    setTrackNameDirty(prev => prev.includes(k) ? prev : [...prev, k]);
    if (row.name.includes("\n")) {
      PostTrackNameChange(k, row.name);
    }
  }
  const toggleVoice = (k) => (ev) => {
    var text = tracks[k].name;
    const talk = text.match('^([0-9]+)@(.*)');
    var retry = 6;
    var voice = parseInt(talk[1]);
    do {
      voice = voice % 6 + 1;
      retry--;
    } while (retry > 0 && voice!==1 && (!voices[voice-1] || !voices[voice-1].lang))
    text = voice + text.substr(1);
    setTracks(tr=>{const n = [...tr]; n[k].name = text; return n});
    latestVoiceRef.current.set(k, text);

    const map = timeoutsRef.current;
    const existing = map.get(k);
    if (existing) clearTimeout(existing);

    // neuen Timer setzen
    const t = setTimeout(() => {
      map.delete(k);      // optional: aufräumen
      const latest = latestVoiceRef.current.get(k);
      PostTrackNameChange(k, latest)
    }, 2000);

    map.set(k, t);
  }

  const DoneTrackChange = (data) => {
    setTracks(data);
    setUploading(false);
    setImageProcess(false);
  }

  const handleTrackBlur = (k) => (event) => {
    const next = event.relatedTarget;

    // Wenn wir auf einen ChannelButton klicken → Blur ignorieren
    if (next && next.dataset?.role === "channel-button") {
      return;
    }

    ensureTrackSaved(k);
  }
  const ensureTrackSaved = (k) => {
      // Wenn schon ein Save-Promise läuft, das wiederverwenden
      if (savePromisesRef.current[k]) {
        return savePromisesRef.current[k];
      }

      // Wenn nichts dirty → nichts zu tun
      if (!trackNameDirty.includes(k)) {
        return Promise.resolve();
      }

      // Name bestimmen
      const name = tracks[k].name;

      setTrackNameDirty(prev => prev.filter(id => id !== k));
      setUploading(tracks[k].id);

      const p = dataprovider.update(
        'track/' + tracks[k].id,
        { channel, id: tracks[k].id, name, filter: { id_project: project.id } },
        DoneTrackChange
      );

      // Promise merken
      savePromisesRef.current[k] = p;

      p.finally(() => {
        if (savePromisesRef.current[k] === p) {
          delete savePromisesRef.current[k];
        }
        setUploading(false);
      });

      return p;
  };

  const PostTrackNameChange = (k, name) => {
    setTrackNameDirty(prev => prev.filter(id => id !== k));
    setUploading(tracks[k].id);
    const p = dataprovider.update('track/'+tracks[k].id, {channel, id:tracks[k].id, name: name, filter:{id_project:project.id}}, DoneTrackChange);
    savePromisesRef.current[k] = p;

    p.finally(() => {
      if (savePromisesRef.current[k] === p) {
        delete savePromisesRef.current[k];
      }
    });
  }
  const handleTrackClick = (id) => (ev) => {
    let as = 0;
    const idx = trackSel.indexOf(id);
    if (idx<0) {
      setTrackSel([...trackSel, id]);
      as = 1;
    }
    else {
      setTrackSel(trackSel.filter(t=>t!==id));
      as = -1;
    }
    const p = projList.find(p=>p.id===parseInt(projSel));
    if (p) {
      if (!p.anzsel) p.anzsel = 0;
      p.anzsel += as;
    }
  }

  const selectAllTracks = () => {
    setTrackSel((ts)=> {
      const t = [...ts];
      trackList.forEach(tl=> {
        if (!t.includes(tl.id)) {
          t.push(tl.id);
        }
      })
      return t;
    });
  }


  const AddTrack = () => {
    dataprovider.insert('track', {channel, filter:{id_project:project.id}}, setTracks);
  }
  
  const AddTalkTrack = () => {
    dataprovider.insert('track', {channel, filter:{id_project:project.id}, name:'1@'}, setTracks);
  }
  
  const DuplicateTrack = () => {
    dataprovider.update('track', {channel, filter:{id_project:project.id}, gettrack:trackSel}, setTracks);
    setDuplitracks(false);
  }
  
  const DeleteTrack = (track_id) => (ev) => {
    dataprovider.del('track/'+track_id, {channel, filter:{id_project:project.id}}, setTracks);
  }

  const SendTranslate = (text) => {
    const k = translateId;
    const rows = [...tracks];
    const row = {...rows[k]};
    row.name = row.name.substr(0,2) + (text===false?translated:text);
    rows[k] = row;
    setTracks(rows);
    PostTrackNameChange(k, row.name);
    setTranslating(0);
    setTranslateId(false);
  }
  const openTranslate = (trackid) => {
    if (trackid !== lastTransId) {
      setTranslateText('');
      setTranslated('');
      setTranslating(0);
      setLastTransId(trackid); 
    }
    setTranslateId(trackid);
  }

  const DoneTranslate = (data) => {
    const talk = tracks[translateId].name.match('^([0-9]+)@(.*)');
    const v = voices[talk[1]-1];
    if (v && v.lang && v.lang.substr(0, 2) !== 'ch') {    
      SendTranslate(data.text);
      return;
    }
    setTranslated(data.text);
    setTranslating(2);
  }

  const DoTranslate = (ev) => {
    setTranslating(1)
    dataprovider.insert('track/translate', {text:translateText, lang:parseInt(tracks[translateId].name.substr(0,1)), id_project:project.id }, DoneTranslate);
  }
  const handleUploadClick = (ev) => {
    setUploadId(1);
  }
  const CloseUploadModal = (ev) => {
    setUploadId(0);
  }
  
  const StartStopRec = (trackid) => (ev) => {
    if (rmr.status==='recording') {
      clearInterval(recInterval);
      stopRecording();
    }
    else {
      window.trackid = trackid;
      setRecSeconds(0);
      setRecInterval(setInterval(() => { setRecSeconds(recSecounds => recSecounds + .2); }, 200));
      startRecording();
    }
  }
  
  const PlayAudio = async (k) => {

    let urlToPlay = tracks[k].docurl;

    const pending = savePromisesRef.current[k];
    if (pending) {
      try {
        const data = await pending;
        if (data && data[k].docurl) {
          urlToPlay = data[k].docurl;
        }
      } catch (e) {
        console.error("Fehler beim Speichern/Generieren:", e);
        return; 
      }
    }

    if (playing!==false) {
      setPlaying(false);
      audio.pause();
    }
    else {
      setPlaying(k);
      audio.src = urlToPlay;
      audio.load();
      await audio.play();
    }
  }

  const openImage = (trackid) => {
    if (tracks[trackid].img_props) {
      setImgProps(JSON.parse(tracks[trackid].img_props));
    }
    else {
      setImgProps({scale: 1, offset: {x: 0, y: 0}});
    }
    setImageIndex(trackid);
  }

  const setRahmenFarbe = (trackid, farbe) => {
    dataprovider.update('track/updateColor', {id: trackid, farbe, filter: { id_project: project.id }}, setTracks);
  }
  const setBgFarbe = (trackid, farbe) => {
    dataprovider.update('track/updateColor', {id: trackid, back:true, farbe, filter: { id_project: project.id }}, setTracks);
  }
  const removeImage = (trackid) => {
    dataprovider.update('track/updateColor', {id: trackid, remove:true, filter: { id_project: project.id }}, setTracks);
  }
  const UpdatePrintmode = (ev)=> {
    setUserField('printmode', ev.target.value);
  }
  
  const FormatTime = (t) => {
    var s = '';
    s += ('0'+Math.floor(t/60)).slice(-2);
    s += ':';
    s += ('0'+(Math.floor(t)%60)).slice(-2);
    s += '.';
    s += (''+t).slice(-1);
    return s;
  }
  const grid=8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // styles we need to apply on draggables
    ...draggableStyle
  });
  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#eee" : "",
    padding: grid,
  });  

  const onDragStart = (result) => {
    ensureTrackSaved(result.source.index);
  }
  const onDragEnd = (result) => {
    const src = result.source.index;
    const dst = result.destination.index;
    if (!result.destination || src===dst) {
      return;
    }
    const srcpos = tracks[src].pos;
    const dstpos = tracks[dst].pos;

    setTracks(tr=>{
      const tr2 = JSON.parse(JSON.stringify(tr));
      if (dst >= tr2.length) {
        tr2.push(undefined);
      }
      tr2.splice(dst, 0, tr2.splice(src, 1)[0]);
      return tr2;
    })

    console.log(tracks, srcpos, dstpos);
    dataprovider.update('track/'+srcpos, {channel, move:dstpos, filter:{id_project:project.id}}, setTracks);
  }

  const FileUploadCompleted = (data) => {
    setTracks(data);
    setUploading(false);
  }
  const UploadError = (data) => {
    setUploading(false);
    setImageProcess(false);
  }
  const onDrop = acceptedFiles => {
    var formData = new FormData();
    formData.append('id_project', project.id);
    formData.append('channel', channel);
    formData.append('dateinamen', + dateinamen);
    formData.append('skipProcessAudio', + !processAudio);
    var pos = tracks.length;
    const tr = [...tracks];
    acceptedFiles.forEach((f, k) => {
      tr.push({id:k+1000, pos:pos++, name: '', id_doc:0, duration:0, docurl:''});
      pos++;
      formData.append('files'+k, acceptedFiles[k]);
    });
    setUploading(1000);
    setTracks(tr);
    dataprovider.upload('track', 0, formData, FileUploadCompleted, UploadError);
    setUploadId(0);
  };

  const resizeJpegIfNeeded = async (file, maxDim = 2000, quality = 0.9) => {
    if (file.type !== 'image/jpeg') {
      return file;
    }
    try {
      const bitmap = await createImageBitmap(file);
      const { width, height } = bitmap;
      if (width <= maxDim && height <= maxDim) {
        bitmap.close();
        return file;
      }
      const scale = Math.min(maxDim / width, maxDim / height);
      const targetWidth = Math.round(width * scale);
      const targetHeight = Math.round(height * scale);
      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight);
      bitmap.close();
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
      if (!blob) {
        return file;
      }
      return new File([blob], file.name, { type: 'image/jpeg' });
    } catch (e) {
      console.error('Bildskalierung fehlgeschlagen', e);
      return file;
    }
  };

  const onDropImage = async acceptedFiles => {
    setImageProcess(true);
    var formData = new FormData();
    formData.append('id_project', project.id);
    formData.append('id_track', tracks[imageIndex].id);
    const processedFiles = await Promise.all(acceptedFiles.map(f => resizeJpegIfNeeded(f)));
    processedFiles.forEach((f, k) => {
      formData.append('files'+k, f);
    });
    dataprovider.upload('track/image', 0, formData, DoneTrackChange, UploadError);
  };

  const codeZipFinish = (res) => {
    updateExportOptions('download', res.id);
  }
  const codeZipErstellen = () => {
    updateExportOptions('progress', 0);
    dataprovider.update('project/export/'+project.id, {...exportOptions, printmode:userinfo.printmode}, codeZipFinish);
    setTimeout(GetProgress, 500);
  }
  const updateCodeProgress = (res) =>{
    const v = res.value;
    if (v) {
      const s = v.split('/');
      if (s.length>1) {
        const max = parseInt(s[1]);
        if (max > 0) {
          const pos = parseInt(s[0]);
          updateExportOptions('progress', Math.round(100/max * pos));
          if (pos < max) {
            setTimeout(GetProgress, 500);
          }
        }
      }
    }
  }
  const GetProgress = () => {
    dataprovider.getRow('progress', 0, false, updateCodeProgress);
  }


  const {getRootProps, getInputProps} = useDropzone({onDrop, accept:'audio/*'});
  const dropImg = useDropzone({onDrop: onDropImage, accept: "image/*"});
  const token = getGlobalData('token');
  const qrurl = 'https://'+dataprovider.apiUrl+"/qr?token="+token+"&url="+window.location.origin+"/kc%23"+
    (kids.id>0?project.kidscreator:project.kidscreatorNew);  

  if (!userinfo || !userinfo.id) {
    return (
      <>
        <Slider staticel={staticel} page={8} is_dev={is_dev} />
        <div className="container mt-5">
          <div className="row mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
            <div className="col">
              <h4>Werde hier mit dem Creator innovativ</h4>
              <p>Du musst dich <a href="/app#login">anmelden</a> oder <a href="/app#register">registrieren</a> und brauchst eine Lizenz.</p>
            </div>
          </div>
        </div>
      </>
    )
  }
  
  if (userinfo.license < 1) {
    return (
      <>
        <Slider staticel={staticel} page={8} is_dev={is_dev} />
        <div className="container mt-5">
          <div className="row mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
            <div className="col">
              <h4>Werde hier mit dem Creator innovativ</h4>
      {userinfo.license===-1?
                <p>Kaufe dir eine Lizenz im <a href="/app#shop/s114">Shop</a>.</p>
      :
                <p>Verlängere deine abgelaufen <a href="/app#license">Lizenz</a>.</p>
      }
            </div>
          </div>
        </div>
      </>
    )
  }

  const allowTTSch = true; //project.username && ['andreas.arn@alixon.ch', 'info@soundolino.ch', 'achimamuck@gmail.com'].indexOf(project.username)>=0;
  //console.log(exportOptions)

  const TrackNumber = ({k, p}) => {
    const hc = project.has_channels;
    const tg = project.toggle;
    if (hc) p--;
    if (k===0) return (<i className="bi bi-power fs-5"/>);
    if (p===0 && hc) return (<i className={"bi bi-"+channelIcons[channel]+" fs-5"} />);
    if (tg) p = Math.floor((p+1)/2)+(p%2>0?'a':'b');
    const minlen = tg?3:2;
    const pstr = p.toString().padStart(minlen, '0');
    return pstr;
  }

  const switchChannel = (ch) => {
    trackNameDirty.forEach((k) => {
      ensureTrackSaved(k);
    });
    setChannel(ch);
  }
  const ChannelButton = ({ch}) => {
    return (
      <button type="button" className={"btn btn-"+(channel===ch?"primary":"secondary")+" ms-2 me-0 py-1 px-4"} onClick={()=>{switchChannel(ch)}} title="Kanal 1" data-role="channel-button">
        <i className={"bi bi-"+channelIcons[ch]+" fs-5"}></i>
      </button>
    )
  }

  if (project.id===0) {
    return (
      <>
      <Slider staticel={staticel} page={8} is_dev={is_dev} />
      <div className="container mt-2 pt-5">
        <div className="row mb-1 mt-3 p-5" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
          <h5>Du hast die maximale Projektanzahl von 300 Projekten erreicht!</h5>
          <p>Aus technischen Gründen können wir die Anzahl Projekte nicht erhöhen. Du hast zwei Möglichkeiten, um neue Projekte erstellen zu können. </p>
          <h6>Option 1 – Schnell und einfach</h6>
          <p>Lösche im Creator Projekte, die du nicht mehr verwendest. Dadurch werden sofort Projektplätze frei, und du kannst wieder neue Projekte anlegen.</p>
          <h6>Option 2 – Etwas aufwändiger, dafür nachhaltig</h6>
          <p>Nutze die Funktion „Tracks holen“, um mehrere bestehende Projekte (z. B. viele Bilderbuch-Projekte) zu einem grossen Projekt zusammenzuführen. Das bringt langfristig mehr Übersicht und viele freie Projektnummern.</p>
          <p>So gehst du vor:</p>
          <ul>
              <li>Fasse mithilfe der Funktion „Tracks holen“ verschiedene Inhalte, etwa mehrere Bücher, in einem Projekt zusammen.</li>
              <li>Startsticker nicht besprechen oder mit einer Ansage versehen, welche für alle Projektinhalte passend ist. Wähle bei den Optionen im Creator (Zahnradsymbol) den Druck von mehreren Startstickern aus.</li>
              <li>Die Buchtitel oder Unterprojekt-Titel, welche du vielleicht bereits aufgenommen hast, kannst du jeweils als eigene „normale“ Tracks aufnehmen.</li>
          </ul>
          <p>Beispiel: Ein „gebündeltes“ Projekt kann so zum Beispiel bis zu 50 Bücher mit jeweils 20 Stickern enthalten.</p>
          <h6>Wichtig: Wenn du auf diese Weise Projekte bündelst, musst du die Sticker natürlich erneut ausdrucken und einkleben sowie den Hörstift erneut mit der soundolino bridge synchronisieren.</h6>
          <p>Falls wir dich unterstützen können, darfst du dich gerne unter <a href="mailto:info@soundolino.ch">info@soundolino.ch melden.</a></p>
        </div>
      </div>
      </>
    )
  }

//console.log(tracks);
  const ExportNoQR = exportOptions.typ==='qr' && tracks.length<2;

//  console.log(project.has_channels)

  return (
    <>
      <Slider staticel={staticel} page={8} is_dev={is_dev} />
      <div className="container mt-2 pt-5">
        <div className="d-flex mb-3">
          <button type="button" className="btn btn-primary ms-2 p-2" onClick={CreateProject}><i className="bi bi-plus-lg"></i> Neues Projekt</button>
          <button type="button" className="btn btn-primary ms-2 me-auto p-2" onClick={MeineProjkete}><i className="bi bi-card-list"></i> Meine Projekte</button>
          <button type="button" className="btn btn-danger ms-2 p-2" onClick={()=>setKids({id:-userinfo.id, titel:''})}><i className="bi bi-plus-lg"></i> KidsCreator</button>
        </div>
        <div className="row mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
          <div className="d-flex px-0">
            <input value={project.name} placeholder="Projektname" onChange={HandleNameChange} style={{color:nameDirty?'red':'',width:'80%',maxWidth:'20em'}} />
    {project.id>0 &&
            <button type="button" className="btn btn-primary ms-2 py-1 px-2" data-bs-toggle="modal" data-bs-target="#delproj" title="Projekt löschen">
              <i className="bi bi-trash fs-5"></i>
            </button>
    }
    {project.id>0 && !project.has_channels &&
            <button type="button" className={"btn btn-"+(project.toggle?'primary':'secondary')+" ms-2 py-1 px-2"} data-bs-toggle="modal" data-bs-target="#toggle" title="Wechsel-Sound">
               <svg className="bi bi-123" width="16" height="16" fill="currentColor" version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.55 0 0 1.55 -4.94 -4.45)" fill="#FFF" aria-label="2x"><path d="m8 10.4v0.845h-4.73q-0.00977-0.317 0.103-0.61 0.181-0.483 0.576-0.952 0.4-0.469 1.15-1.08 1.17-0.957 1.58-1.51 0.41-0.562 0.41-1.06 0-0.522-0.376-0.879-0.371-0.361-0.972-0.361-0.635 0-1.02 0.381-0.381 0.381-0.386 1.05l-0.903-0.0928q0.0928-1.01 0.698-1.54 0.605-0.532 1.63-0.532 1.03 0 1.63 0.571 0.601 0.571 0.601 1.42 0 0.43-0.176 0.845-0.176 0.415-0.586 0.874-0.405 0.459-1.35 1.26-0.791 0.664-1.02 0.903-0.225 0.234-0.371 0.474z"/><path d="m8.6 11.3 1.89-2.7-1.75-2.49h1.1l0.796 1.22q0.225 0.347 0.361 0.581 0.215-0.322 0.396-0.571l0.874-1.23h1.05l-1.79 2.44 1.93 2.74h-1.08l-1.06-1.61-0.283-0.435-1.36 2.05z"/></g></svg>
            </button>
     }
    {project.id>0 &&
            <button type="button" className="btn btn-primary ms-2 me-auto py-1 px-2" title="Projekt Einstellungen" onClick={()=>setSettings(true)}>
              <i className="bi bi-gear fs-5"></i>
            </button>
     }
    {project.id>0 && (userinfo.email==='info@soundolino.ch' || userinfo.email==='achim@arns.ch' || userinfo.email.slice(-10)==='@alixon.ch') &&
            <button type="button" className="btn btn-primary ms-2 py-1 px-2" data-bs-toggle="modal" data-bs-target="#archiveproj" title="Projekt archivieren / wiederherstellen">
              <svg className="bi bi-cloud-upload" width="20" height="20" fill="currentColor" version="1.1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fillRule="evenodd"><path d="m5.9652 2.3801c1.1053-0.95308 2.5149-1.4794 3.9744-1.484 2.9747 0 4.9707 2.4821 5.2394 5.3341 1.7605 0.24881 3.6072 1.4524 3.6072 3.2616 0 1.9861-1.6565 3.5685-3.6636 3.5685h-9.8485c-2.2924 0-4.1811-1.8069-4.1811-4.0717 0-1.9496 1.6837-3.1857 3.5371-3.5949 0.15813-0.95433 0.4881-2.2837 1.3352-3.0135" fill="none" stroke="#fff" strokeWidth="1.6"/><path d="m7.3683 7.4939c0.2488-0.26301 0.65286-0.26301 0.90166 0l2.8159 3.0174c0.59625 0.63892-0.30055 1.5846-0.90166 0.95076l-1.7283-1.8719v9.1222c0 0.89525-1.2735 0.89525-1.2735 0v-9.1222l-1.7283 1.8558c-0.60111 0.63384-1.4995-0.31352-0.90166-0.95076z" strokeWidth="1.3077"/><path d="m13.608 19.136c-0.2488 0.26301-0.65286 0.26301-0.90166 0l-2.8159-3.0174c-0.59625-0.63892 0.30055-1.5846 0.90166-0.95076l1.7283 1.8719v-9.1222c0-0.89525 1.2735-0.89525 1.2735 0v9.1222l1.7283-1.8558c0.60111-0.63384 1.4995 0.31352 0.90166 0.95076z" strokeWidth="1.3077"/></g></svg>
            </button>
    }
    {!project.has_channels &&
            <button type="button" className="btn btn-danger ms-2 me-0 py-1 px-2" onClick={()=>{setKids({id: project.id, titel:project.name})}} title="KidsCreator">
              <i className="bi bi-pencil fs-5"></i>
            </button>
    }
          </div>
    {project.has_channels>0 &&
          <div className="row mt-3" >
            <div className="d-flex px-0 align-items-center">
              <div>Kanäle:</div>
      {Array.from({ length: project.sprachpaket ? 6 : project.has_channels }).map((_, i) => (
              <ChannelButton ch={i} />
      ))}
            </div>
          </div>
    }
          <hr className="mt-3 mb-1" />
          <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div className="container"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}> 
        {tracks && tracks.map((tr, k)=>{
          if (project.has_channels && tr.channel!==channel) return false;
          let name = tr.name;
          let voice = '';
          let speed = 1;
          const talk = name.match('^([0-9]+)@(.*)');
          if (talk) {
            name = talk[2];
            const v = voices[talk[1]-1];
            if (v && v.lang) {
              if (v.lang.substr(0, 2) === 'ch') {
                voice = (v && v.lang?v.lang:'de').substr(3, 2).toLowerCase();
              }
              else if (v.lang.substr(0, 2) === 'de') {
                voice = 'd'+(v.lang.slice(-4) == 'live'?'2':'1');
              }
              else {
                 voice = (v && v.lang?v.lang:'d1').substr(0, 2).toLowerCase();
              }
            }
            else { 
              voice = 'd1';
            }
            voice += (v && v.voice?v.voice:'W');
            speed = v && v.speed?parseInt(v.speed)+1:2;
          }
          const map = timeoutsRef.current;
          const pending = map.get(k)
          
          const p = tr.pos - 1;
          let bildaktiv = true;
          if (!!project.has_image && (channel>0 && p>1)) {
            console.log(tr, tracks);
            const reftr = tracks.find(t=>t.channel===0 && tr.pos===t.pos);
            if (reftr && reftr.imageurl) {
              tr.imageurl = reftr.imageurl;
              tr.img_props = reftr.img_props;
            }
            bildaktiv = false;
          }
          if (project.toggle && p>0 && p%2===0) {
            const reftr = tracks[k-1];
            tr.imageurl = reftr.imageurl;
            tr.img_props = reftr.img_props;
            bildaktiv = false;
          }
          const imgMod = tr.img_props?JSON.parse(tr.img_props):{};
          return (
                  <Draggable key={tr.id} draggableId={String(tr.id)} index={k}>
                    {(provided, snapshot) => {
                      return (
                    <div className="row mb-1 mt-1" id={'track'+k} ref={provided.innerRef} {...provided.draggableProps}
                                  style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                      <div className="col-auto p-0 d-flex align-items-center">
                        <div  {...provided.dragHandleProps} title="Track verschieben"><i className="bi bi-grip-vertical"></i></div>
                      </div>
                      <div className="col-auto p-0 d-flex align-items-center justify-content-center" style={{minWidth:'25px'}}>
                        <TrackNumber k={k} p={p} hc={project.has_channels>0} />
                      </div>
                      <div className="col-4 d-flex align-items-center">
                        <textarea value={name} placeholder={talk?"Talk-Track Text":"Titel"} rows={1} onChange={HandleTrackNameChange(k, talk)} onBlur={handleTrackBlur(k)}
                          style={{color:trackNameDirty.includes(k)?'red':'', height:tracksHights[k]?tracksHights[k]+'px':'auto', width:'100%', overflow:'hidden', resize:'none'}} />
                      </div>
                      <div className="col-auto p-0 d-flex align-items-center text-end" style={{width:'3.5em'}}><span style={{width:'95%'}}>
              {uploading===tr.id && 
                          <svg className="circlespinner" viewBox="0 0 50 50">
                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                          </svg>
              }
                          {uploading===tr.id?'':(tr.id===window.trackid?FormatTime(recSecounds):FormatTime(tr.duration))}
                      </span></div>
                      <div className="col-auto p-0 d-flex align-items-center" style={{width:'50px'}}>
              {(tr.duration>0 || (name!=='' && talk) )&& 
                        <button type="button" className="btn btn-secondary ms-1 py-1 px-2" onClick={()=>PlayAudio(k)} title={playing===k?"Abspielen stoppen":"Track abspielen"} disabled={pending}><i className={"bi fs-5 bi-"+(playing===k?"stop":"play")+"-fill"}></i></button>
              }
                      </div>
                      <div className="col-auto p-0 d-flex align-items-center">
              {!talk &&
                        <button type="button" className={"btn btn-secondary ms-1 py-1 px-2"+(rmr.status==='recording' && tr.id===window.trackid?" btn-danger":"")} onClick={StartStopRec(tr.id)} 
                          title={rmr.status==='recording' && tr.id===window.trackid?"Aufnahme stoppen":"Track aufnehmen"}>
                          {rmr.status==='recording' && tr.id===window.trackid?<i className="bi bi-stop-fill fs-5" />:<i className="bi bi-mic-fill fs-5"/>}
                        </button>
              }
              {!!talk &&
                        <button type="button" onClick={toggleVoice(k)} className="btn btn-secondary ms-1 py-2 px-1 position-relative" title="Talk Track" style={{fontSize:'0.9em', width:'38px', letterSpacing:'1px'}}>
                          {voice}
                          <div className="speed-dots">{'.'.repeat(speed)}</div>
                        </button>
              }
                      </div>
              {((!project.has_channels && k>0) || (project.has_channels>0 && p>1)) ?
                      <div className="col-auto p-0 d-flex align-items-center"><button type="button" className="btn btn-secondary ms-1 py-1 px-2" onClick={DeleteTrack(tr.id)} title="Track löschen"><i className="bi bi-trash fs-5"></i></button></div>
              :
                      <div className="col-auto p-0 d-flex align-items-center" style={{width:'42px'}}></div>
            }
              {!!project.has_image && !tr.imageurl && (channel===0 || p===1) &&
                      <div className="col-auto p-0 d-flex align-items-center"><button type="button" className="btn btn-secondary ms-1 py-1 px-2" onClick={()=>openImage(k)} title="Bild einsetzen"><i className="bi bi-image fs-5"></i></button></div>
              }
              {!!project.has_image && tr.imageurl && bildaktiv &&
                      <div className="col-auto p-0 d-flex align-items-center ms-1">
                        <div style={{border:"2px solid "+tr.frame, borderRadius:"3px", backgroundColor:tr.background, cursor:'pointer', overflow:'hidden'}} onClick={()=>openImage(k)}>
                          <img src={tr.imageurl} style={{width:'40px', height:'40px', 
                            transform: imgMod && imgMod.offset?`translate(${imgMod.offset.x*0.231}px, ${imgMod.offset.y*0.231}px) scale(${imgMod.scale})`:null }} />
                        </div>
                      </div>

              }
              {!!project.has_image && tr.imageurl && !bildaktiv &&
                      <div className="col-auto d-flex align-items-center ms-1" 
                          style={{padding:'2px', borderRadius:"3px", overflow:'hidden'}}>
                        <img src={tr.imageurl} style={{width:'40px', height:'40px', 
                          transform: imgMod && imgMod.offset?`translate(${imgMod.offset.x*0.231}px, ${imgMod.offset.y*0.231}px) scale(${imgMod.scale})`:null,
                          opacity: 0.35
                          }} />
                      </div>

              }
              {!!talk && voice.substr(0,2)!=='d1' && voice.substr(0,2)!=='d2' &&
                      <div className="col-auto p-0 d-flex align-items-center"><button type="button" onClick={()=>openTranslate(k)} className="btn btn-secondary ms-1 py-2 px-1" title="Übersetzen" style={{fontSize:'0.9em', width:'38px'}}>T</button></div>
              }
                    </div>
                  )}}
                  </Draggable>                  
        )})}              
                  {provided.placeholder}
                  <div className="col-4 d-flex align-items-center">
                    <textarea ref={textareatRef} style={{width:'100%', visibility:'hidden'}} />
                  </div>
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="d-flex px-0">
            <button type="button" className="btn btn-primary me-1 mt-1" onClick={AddTrack}><i className="bi bi-plus-lg"></i> Neuer Track</button>
            <button type="button" className="btn btn-primary me-1 mt-1" onClick={handleUploadClick}><i className="bi bi-cloud-upload"></i> Upload</button>
        {!isMobile() && <button type="button" className="btn btn-primary me-1 mt-1" onClick={()=>setDuplitracks(true)}><i className="bi bi-chevron-double-down"></i> Tracks holen</button>}
            <button type="button" className="btn btn-primary me-auto mt-1" onClick={AddTalkTrack}><i className="bi bi-plus-lg"></i> Talk-Track</button>
            <button type="button" className="btn btn-success me-0 mt-1" onClick={()=>setExportOptions({})}><i className="bi bi-download"></i> Export</button>
          </div>
        </div>
      </div>
      <DelProj name={project.name} DeleteProject={DeleteProject} />
      <ArchiveProj name={project.name} proj={project.id} dataprovider={dataprovider} />
      <Projsettings project={project} setProject={setProject} PostSettingChange={PostSettingChange} setTracks={setTracks} dataprovider={dataprovider} 
        show={settings} setShow={setSettings} allowTTSch={allowTTSch} userinfo={userinfo} />
      <Toggle active={project.toggle} PostSettingChange={PostSettingChange} />
    {translateId !== false && 
      (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Deutsch <span style={{position:'relative',top:'-0.1em'}}>&rarr;</span> {voiceoptions[voices[parseInt(tracks[translateId].name.substr(0,1))-1].lang].name}</h2>
              <button type="button" className="btn-close" onClick={()=>setTranslateId(false)}></button>
            </div>
            <div className="modal-body">
              <textarea value={translateText} className="form-control" onChange={(ev)=>setTranslateText(ev.target.value)} autoFocus />
              <button type="submit" className="btn btn-primary mt-3" data-bs-dismiss="modal" onClick={DoTranslate} disabled={translating===1}><i className="bi bi-globe"/> Übersetzen</button>
        {translating===1 &&
              <svg className="circlespinner mt-4 ms-4" viewBox="0 0 50 50" style={{position: 'relative', top:'-3px'}}>
                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
              </svg>
        }
        {translating>1 &&
          <>
              <textarea value={translated} className="form-control mt-4" onChange={(ev)=>setTranslated(ev.target.value)} autoFocus />
              <button type="submit" className="btn btn-primary mt-3 mb-1" data-bs-dismiss="modal" onClick={(ev)=>SendTranslate(false)} disabled={translating===1}><i className="bi bi-box-arrow-in-down-left"/> Übernehmen</button>
          </>
        }
            </div>
          </div>
        </div>
      </div>
      )
    }
    {imageIndex !== false && tracks[imageIndex] && 
      (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-sm modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Bild / Symbol</h2>
              <button type="button" className="btn-close" onClick={()=>setImageIndex(false)}></button>
            </div>
            <div className="modal-body">
              <table>
                <tbody>
                  <tr>
                    <ImagePreviewEditor dropImg={dropImg} tracks={tracks} imageIndex={imageIndex} project={project}
                      imageUrl={tracks[imageIndex].imageurl}
                      project={project}
                      imageProcess={imageProcess} removeImage={removeImage}
                      imgProps={imgProps} setImgProps={setImgProps}
                    />
                  </tr>
                  <tr>
                    <td style={{verticalAlign:'top',paddingTop:'0.5em'}}>Rahmen</td>
                    <td style={{paddingRight:'2em',paddingTop:'0.5em'}}>
  {rahmenFarben.map((color,i)=>{ 
    const border = tracks[imageIndex].frame===color?'3':(color==="#FFFFFF"?'1':'0');      
    return (
                      <div key={i} style={{backgroundColor:color, width:'1.5em', height:'1.5em', marginRight:'0.2em', borderRadius:'0.25em', border:border+'px solid black', display:'inline-block'}} onClick={()=>setRahmenFarbe(tracks[imageIndex].id, color)}></div>
  )})}
                    </td>
                  </tr>
                  <tr style={{verticalAlign:'top'}}>
                    <td style={{paddingRight:'0.5em',paddingTop:'0.5em'}}>Hintergrund&nbsp;</td>
                    <td style={{paddingRight:'2em',paddingTop:'0.5em'}}>
  {bgFarben.map((color,i)=>{ 
    const border = tracks[imageIndex].background===color?'3':(color==="#FFFFFF"?'1':'0');      
    return (
                    <div key={i} style={{backgroundColor:color, width:'1.5em', height:'1.5em', marginRight:'0.2em', borderRadius:'0.25em', border:border+'px solid black', display:'inline-block'}} onClick={()=>setBgFarbe(tracks[imageIndex].id, color)}></div>
  )})}
                    </td>
                  </tr>
                </tbody>
              </table>
              <button type="button" className="btn btn-primary mt-2" onClick={applyImage} >übernehmen</button>
            </div>
          </div>
        </div>
      </div>
      )
    }
    {uploadId > 0 && 
      (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Audio Datei hochladen</h2>
              <button type="button" className="btn-close" onClick={CloseUploadModal}></button>
            </div>
            <div className="modal-body">
              <div style={{marginBottom:'8px'}}>Hinweis: Es ist untersagt Inhalte hochzuladen, welche urheberrechtlich geschützt sind!</div>
              <div className="form-check form-switch mb-1">
                <input checked={dateinamen} onChange={HandleDateinamen} className="form-check-input" type="checkbox" role="switch" id="setNames" />
                <label className="form-check-label" for="setNames">Dateinamen übernehmen</label>
              </div>

              <div className="form-check form-switch mb-4">
                <input checked={processAudio} onChange={HandleProcessAudio} className="form-check-input" type="checkbox" role="switch" id="setNames" />
                <label className="form-check-label" for="setNames">Audio aussteuern / trimmen</label>
              </div>

              <div {...getRootProps({className: 'dropzone'})}>
                <input {...getInputProps()} />
                <p style={{display:'block',border:'2px dashed #CCC', padding:'1em', textAlign:'center'}}>Audio Datei hierher ziehen, oder hier klicken</p>
              </div>            
            </div>
          </div>
        </div>
      </div>
      )
    }
    {(kids.id>0 || kids.id<0) && 
      (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-md modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              {kids.id<0 && <h5 className="modal-title">Neues Projekt im KidsCreator starten</h5>}
              {kids.id>0 && <h5 className="modal-title">&laquo;{kids.titel}&raquo; im KidsCreator bearbeiten</h5>}
              <button type="button" className="btn-close" onClick={()=>setKids({id:0})}></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col">
                  <div className="pb-3">via QR-Code für mobile Geräte</div>
                  <a href={qrurl} target="_blank" rel="noreferrer"><img id="QRimg" src={qrurl} alt="QR Code für Kidscreator" /></a>
                  <button type="button" className="btn btn-primary ms-1 py-1 px-2" onClick={()=>setCopyQR(true)} title="QR-Code kopieren"><i className="bi bi-clipboard fs-5"></i></button>
                </div>
                <div className="col">
                  <div className="pb-3">via Browser für dieses Gerät</div>
                  <a href={"/kc#"+(kids.id>0?project.kidscreator:project.kidscreatorNew)} target="_blank" type="button" className="btn btn-danger py-2" rel="noreferrer">KidsCreator öffnen</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )
    }
    {copyQR && 
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">QR-Code kopieren</h5>
              <button type="button" className="btn-close" onClick={()=>setCopyQR(false)} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              Per rechtem Mausklick -> &laquo;Bild kopieren&raquo; kannst du den QR-Code in die Zwischenablage kopieren
            </div>
          </div>
        </div>
      </div>
    }
    {exportOptions!==false && 
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Codes exportieren (PNG)</h5>
              <button type="button" className="btn-close" onClick={()=>setExportOptions(false)} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div>
    {!project.has_channels &&
                <button type="button" className={"btn btn-"+(exportOptions.typ==='qr'?"primary":"secondary")} onClick={changeExportOptions('typ', 'qr')}>QR Codes</button>
    }
                <button type="button" className={"btn ms-2 btn-"+(exportOptions.typ==='tiptoi'?"primary":"secondary")} onClick={changeExportOptions('typ', 'tiptoi')}>Tiptoi Codes</button>
    {!project.has_channels &&
                <button type="button" className={"btn ms-2 btn-"+(exportOptions.typ==='bookii'?"primary":"secondary")} onClick={changeExportOptions('typ','bookii')}>Bookii Codes</button>
    }
              </div>
    {(exportOptions.typ==='tiptoi' || exportOptions.typ==='bookii') && 
              <div>
                <div className="mt-3">
                  <label htmlFor="homepen" className="form-label">Wähle in welcher Grösse du deine Codes brauchst:</label>
                  <select className="form-select" value={exportOptions.size} onChange={changeExportOptions('size', false)} id="size" style={{width:'15em'}}>
                    <option value="20">Standard quadratisch 23.5mm</option>
                    <option value="40">Mittel quadratisch 43.5mm</option>
                    <option value="60">Gross quadratisch 63.5mm</option>
                  </select>
                </div>
                <div className="mt-3">
                  <label htmlFor="homemode" className="form-label">Wähle den passenden Exportmodus für deinen Drucker:</label>
                  <select className="form-select" value={userinfo.printmode} onChange={UpdatePrintmode} id="homemode" style={{width:'10em'}}>
                    <option key={0} value={0}>Bitte wählen</option>
          {PrintModi.map((p) =>
                    <option key={p} value={p}>{p}</option>
          )}
                  </select>
                </div>
              </div>
            }
              <div className="mt-3 mb-3">
        {(!exportOptions.typ || exportOptions.typ==='qr') && !project.has_channels &&
                 <>Wie du die QR Codes in ein Dokument integrierst erklären wir dir <a href="/tipps/286">hier</a><br /> </> 
        }
        {(!exportOptions.typ || exportOptions.typ!=='qr') &&
                 <>Wie du die Hörstift Codes in ein Dokument integrierst erklären wir dir <a href="/tipps/290">hier</a></>
        }
              </div>
        {ExportNoQR &&
                 <p className="text-danger">Fehlende Tracks: Für QR-Codes braucht es mindesten 2 Tracks.</p> 
        }
        {(userinfo.printmode!=='' && userinfo.printmode!=='0' || exportOptions.typ==='qr')
           && exportOptions.typ && !exportOptions.progress && !exportOptions.download && !ExportNoQR &&             
              <button className="btn btn-primary" onClick={codeZipErstellen}><i className="bi bi-export"/> Codes erstellen</button>
        }       
        {!!exportOptions.progress &&
              <div className="progress" role="progressbar" style={{height: "30px"}}>
                <div className="progress-bar" style={{width: exportOptions.progress+"%"}}>{exportOptions.progress}%</div>
              </div>              
        }
        {!!exportOptions.download &&
              <a href={'https://'+dataprovider.apiUrl+"/download/"+exportOptions.download+".zip"} target="_blank" rel="noreferrer" className="btn btn-primary mt-4" onClick={()=>setExportOptions(false)}><i className="bi bi-export"/> ZIP herunterladen</a>
        }
            </div>
          </div>
        </div>
      </div>
    }
    {duplitracks && 
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Tracks holen</h5>
              <button type="button" className="btn-close" onClick={()=>setDuplitracks(false)} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Die ausgewählten Tracks werden kopiert und unten angefügt.</p>
              <table className="w-100">
                <tbody>
                  <tr>
                    <td>Projekt</td>
                    <td>
                      <select value={projSel} onChange={(ev)=>setProjSel(ev.target.value)} className="w-100">
            {projList.map((p)=>(
                        <option value={p.id} key={p.id}>({p.anzsel?p.anzsel:0}) &nbsp; {p.name}</option>

            ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Tracks<br/>
                      <button type="submit" className="btn btn-secondary mt-4 me-2" onClick={()=>selectAllTracks()} title="Alle auswählen"><i className="bi bi-check-all"></i></button>
                    </td>
                    <td>
                      <div className="w-100 trackselect" >
            {trackList.map((t)=>(
                        <div onClick={handleTrackClick(t.id)} key={t.id} className={trackSel.includes(t.id)?'tracksel':''}>{t.pos-1} - {t.name}</div>
            ))}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-secondary mt-4 me-2" data-bs-dismiss="modal" onClick={()=>setDuplitracks(false)}>Abbrechen</button>
              <button type="submit" className="btn btn-primary mt-4" data-bs-dismiss="modal" onClick={DuplicateTrack}><i className="bi bi-chevron-double-down"/> {trackSel.length} Tracks holen</button>
            </div>
          </div>
        </div>
      </div>
    }
      <Info msg={infoMsg} setMsg={setInfoMsg} />
    </>
  )
}

export default Creator;

